import { createSelector } from 'reselect';
import { leaderboardSelector } from './simple-selectors';

export const leaderboardBettingOddsSelector = createSelector(
    leaderboardSelector,
    (leaderboard) => leaderboard.bettingOdds
);
